<template>
    <div class="bg_FCFDFF body_bg">
        <nav-bar :navigationIndex="3" />
        <div>
            <div class="top_bar bg_img flex">
                <div class="flex_center flex_column w_1280">
                    <div class="industry_news_title no-select">产业新闻</div>
                    <div class="industry_news_en flex no-select">
                        <div class="line_one"></div> INDUSTRY NEWS <div class="line_two"></div>
                    </div>
                    <div class="new_search_box flex">
                        <input class="new_search_input" v-model="searchParam.title" type="text"
                            placeholder="请输入要查询的关键词" />
                        <div class="new_search_btn cursor flex_center" @click="getSearchTitle">
                            查询
                        </div>
                    </div>
                </div>
            </div>
            <div class="transaction_list w_1400">
                <div class="filter_list flex w_1280">
                    <div class="filter_title no-select">
                        发布日期：
                    </div>
                    <div class="flex_center cursor"
                        :class="searchParam.year == 0 ? 'filter_box_select' : 'filter_box'" @click="selectWay(0)">
                        全部
                    </div>
                    <div class="flex_center cursor"
                        :class="searchParam.year == item ? 'filter_box_select' : 'filter_box'"
                        v-for="(item, index) in yearList" :key="index" @click="selectWay(item)">
                        {{ item }}
                    </div>
                </div>
                <div class="all_list">
                    <div class="w_1400">
                        <div class="notice_list">
                            <div class="notice_box flex cursor"
                                :class="newsId == item.id ? 'select_notice_box fade-background' : ''" v-for="item in newsList"
                                :key="item.id" @mouseenter="newMouseEnter(item.id)" @mouseleave="newMouseLeave"
                                @click="goDetail(item)">
                                <div class="right_drop">
                                    <img v-if="item.imgPath" :src="item.imgPath" alt="">
                                    <img v-else :src="imagePathErr" alt="">
                                </div>
                                <div class="notice_time">
                                    <div class="notice_title text_overflow">
                                        {{ item.title }}
                                    </div>
                                    <div class="notice_text multi_line_ellipsis3">
                                        {{ item.introduce }}
                                    </div>
                                    <div class="flex_between">
                                        <div class="flex">
                                            <div class="notice_info">
                                              {{ formatDate(item.publishTime) }} <!-- 调用方法格式化日期 -->
                                            </div>
                                            <!-- <div class="notice_info">
                  来源：新华社
                </div> -->
                                        </div>
                                        <div @click="goDetail(item)">
                                            <el-icon>
                                                <Right style="color: #2063f3" />
                                            </el-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-info-box flex_center">
                    <!-- <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize"
                        size="large" :disabled="disabled" :background="background" layout="prev, pager, next, jumper"
                        :total="searchParam.total" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" /> -->
                    <pagination ref="paginationRef" :total="searchParam.total" @submitPage="handleCurrentChange"></pagination>
                </div>
            </div>
        </div>
        <bottom-bar></bottom-bar>
    </div>
</template>

<script>
import { articlePage, articleYearList } from "@/utils/newsApi";
import imagePathErr from '@/assets/images/imageError.svg'
import pagination from "@/components/pagination.vue";
// @ is an alias to /src

export default {
    components: {
        pagination
    },
    data() {
        return {
            imagePathErr: imagePathErr,
            searchParam: {
                total: 0,
                pageNum: 1,
                pageSize: 10,
                year: 0,
                title: "",
            },

            yearList: [],
            newsId: "",
            newsList: [],
        }
    },
    mounted() {
        this.getArticleCategory();
    },
    methods: {
      formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
        // 年份列表
        async getArticleCategory() {
            let res = await articleYearList();
            if (res.code == 200) {
                this.yearList = res.data;
                this.getArticlePage();
            }
        },
        // 文章列表
        async getArticlePage() {
            let res = await articlePage(this.searchParam);
            if (res.code == 200) {
                this.newsList = res.rows;
                this.searchParam.total = res.total;
                this.$refs.paginationRef.handlePageNumbers(this.searchParam.total);
            }
        },
        selectWay(year) {
            this.searchParam.year = year;
            this.getArticlePage();
        },

        newMouseEnter(id) {
            this.newsId = id;
        },
        newMouseLeave() {
            this.newsId = 0;
        },
        // 查看详情
        goDetail(item) {
            this.$router.push({
                path: '/listDetails',
                query: {
                    id: item.id,
                    typeValue: item.type,
                }
            });
        },
        getSearchTitle() {
            this.searchParam.pageNum = 1;
            this.getArticlePage();
        },
        handleSizeChange(val) {
            this.searchParam.pageSize = val;
        },
        handleCurrentChange(val) {
            this.searchParam.pageNum = val;
            this.getArticlePage();
        },
    }
}
</script>

<style scoped lang="scss">
.body_bg {
    background: url("@/assets/images/newsbg.png") center no-repeat;
    background-size: cover;
}

.bg_img {
    background: url("@/assets/images/newsBanner.png") center no-repeat;
    background-size: cover;
}

.top_bar {
    width: 100%;
    height: 615px;
}

.transaction_list {
    padding-top: 88px;
    padding-bottom: 104px;
}


.industry_news_title {
    font-weight: bold;
    font-size: 73px;
    color: #FFFFFF;
}

.industry_news_en {
    font-weight: 500;
    font-size: 23px;
    color: #FFFFFF;
}

.line_one {
    width: 186px;
    height: 4px;
    // background: #FFFFFF;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    opacity: 0.2;
    margin-right: 25px;
}

.line_two {
    width: 186px;
    height: 4px;
    // background: #FFFFFF;
    background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
    opacity: 0.2;
    margin-left: 25px;
}

.new_search_box {
    width: 1029px;
    height: 76px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #6DB6F7;
    margin-top: 45px;
}

.new_search_input {
    height: 100%;
    width: 720px;
    font-size: 31px;
    color: #999999;
    border: none;
    padding: 0;
    margin: 0;
    padding-left: 56px;
    outline: none;
    border-radius: 4px 0px 0px 4px;
}

.new_search_btn {
    width: 253px;
    height: 100%;
    background: #2567F1;
    border-radius: 0px 4px 4px 0px;
    border: none;
    margin: 0;
    padding: 0;
    font-weight: normal;
    font-size: 35px;
    color: #FFFFFF;
}

.filter_title {
    font-size: 28px;
    color: #7D7D7D;
    font-weight: 600;
    line-height: 24px;
    margin-right: 20px;
}

.filter_box {
    width: 135px;
    height: 40px;
    background: #F5F7FA;
    border-radius: 6px;
    border: 1px solid #7D88A7;
    font-size: 26px;
    color: #777F9D;
    margin-right: 20px
}

.filter_box_select {
    width: 135px;
    height: 40px;
    background: #284187;
    border-radius: 6px;
    font-size: 26px;
    color: #FFFFFF;
    margin-right: 20px
}

.all_list {
    margin-top: 85px;
    margin-bottom: 128px;
}

.search_tab {
    height: 70px;
    background: rgb(230, 241, 250);

}

.search_tab_box {
    border-radius: 7px;
    padding: 10px;
    font-weight: 600;
    letter-spacing: 2px;
    color: #000;
    font-size: 15px;
}

.select_tab_box {
    color: #fff;
    background: rgb(2, 104, 181);
}

.search_box {
    width: 400px;
    height: 40px;
    padding-right: 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
}

input {
    outline: none;
}

.search_input {
    height: 40px;
    border: none;
    width: 260px;
    border-radius: 4px 0 0 4px;
    margin: 0;
    padding: 0 20px;
}

.search_btn {
    height: 100%;
    width: 100px;
    background: #66b1ff;
    border-radius: 0px 4px 4px 0px;
    font-weight: 400;
    color: #fff;
}

.search_btn span {
    font-weight: 400;
    color: #fff;
    margin-left: 3px;
    line-height: 15px;
    font-size: 15px;
}

.notice_list {
    margin-bottom: 20px;
}

.notice_box {
    height: 210px;
    margin-bottom: 10px;
    padding: 28px 54px;
    border-radius: 7px;
}

.select_notice_box {
    box-shadow: 0 0 2px #d3d3d3;
}

.fade-background {
  animation: backgroundFade 1s infinite; /* 动画名称 持续时间 重复次数 */
}

@keyframes backgroundFade {
  0% {
    background-color: rgba(255, 255, 255, 0); /* 初始颜色 */
  }
  50% {
    background-color: rgba(255, 255, 255, 0.5); /* 中间颜色 */
  }
  100% {
    background-color: rgba(255, 255, 255, 1); /* 最终颜色 */
  }
}

.right_drop {
    width: 324px;
    height: 211px;
    border-radius: 7px;

    img {
        width: 100%;
        height: 100%;
        border-radius: 7px;
        object-fit: cover;
    }
}

.notice_time {
    width: 880px;
    padding: 11px 0;
    margin-left: 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}

.notice_title {
    font-size: 22px;
    color: #313131;
    cursor: pointer;
    font-weight: 700;
}

.notice_text {
    font-size: 20px;
    color: #7D7D7D;
    line-height: 30px;
    margin: 32px 0;
}

.notice_info {
    font-size: 16px;
    color: #2567F1;
    margin-right: 40px;
}
.no-select {
  user-select: none;
  /* 禁止文本选择 */
  pointer-events: none;
  /* 禁止鼠标事件（无法点击、拖动等） */
  -webkit-user-drag: none;
  /* 禁止 WebKit 浏览器拖动 */
  cursor: default;
  /* 更改鼠标样式，避免误导 */
}
</style>